/* Form interceptor for style stix products light up variants
 * implemented at: layout/theme.liquid
 * works with: assets/additional-product-flashlight.js
 */

  async function postCartData(item) {
        try {
          const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(item),
          });
          const data = await res.json();
          return data;
        } catch (error) {
          console.log("Error POST cart data", error);
        }
  }

  // NOTE: Only valid when cart drawer is activated
  const isDrawer = document.querySelector('[data-js-popup-name="cart"]')
  if(isDrawer){
    //console.log({isDrawer})
    const addToCartButton = document.querySelector('.js-product-button-add-to-cart')
    //console.log(addToCartButton)

    async function addFlashlightToCart(){
    const additionalProduct = document.querySelector("[data-js-selected-additional-product-id]")
    const is_product_URL = !!location.href.match(/products/);
    const {value} = additionalProduct
   

    const payload = {
          'items': [{
            'id': Number(value),
            'quantity': 1
          }]
       };

      if(is_product_URL){
        await postCartData(payload)
        console.log("cart drawer - added flashlight")
        //alert("is cart drawer, flaslight added from FN")
      }        
    }

    // IMPORTANT - if time is updated for drawer, assets/theme.js time must be updated
    // assets/theme.js -> 3100
    window.addFlashlightToCart = addFlashlightToCart

    
    // addToCartButton.addEventListener('click', () => {
    //    setTimeout( async ()=>{
    //     const additionalProduct = document.querySelector("[data-js-selected-additional-product-id]")
    //     const {value} = additionalProduct
       

    //     const payload = {
    //           'items': [{
    //             'id': Number(value),
    //             'quantity': 1
    //           }]
    //        };

    //       await postCartData(payload)
    //       console.log("cart drawer - added flashlight")
    //     },2000)
    // })
  }

  // NOTE: When cart drawer is activated form will not be subbmited  
  const form = document.querySelector('[data-js-product-form]');

  // Store the original method
  const tmp = form.submit;

  // create an intercept and override the submit method for the form with it
  form.addEventListener("submit", async (e)=>{
    e.preventDefault()
    e.stopPropagation()

    const additionalProduct = document.querySelector("[data-js-selected-additional-product-id]")
    const {value} = additionalProduct

    const payload = {
          'items': [{
            'id': Number(value),
            'quantity': 1
          }]
       };

    await postCartData(payload)
    
    
   
    // IMPORTANT - if time is updated for drawer, assets/theme.js time must be updated
    // Trigger form
    setTimeout(()=>{
       tmp.apply(form);
    },2500)
    
  })

//NOTE: Detect inline egraving type canes 
// https://fashionablecanes.com/products/engravable-chrome-color-crystal-derby-cane-invisible-acrylic
document.addEventListener("DOMContentLoaded", function () {


  function whenAvailable(DOM_element, callback, number_of_trys = 0) {
    number_of_trys += 1;
    const appEl = document.querySelector(DOM_element)
    const interval = 1000; 
  
    //console.log( number_of_trys)
    const int = window.setTimeout(function() {
        if (appEl) {
            callback(appEl);
            clearInterval(int)
        } else {
           console.log(`Waiting for DOM ENGRAVING INLINE ELEMENT ${DOM_element} to be available...`);
           number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys DOM ENGRAVING INLINE ELEMENT", number_of_trys);
        }
    }, interval);
  }


  whenAvailable(".product-personalizer", (el) => {
    console.log("zepto INLINE ENGRAVING loaded", el)

    const isInlineEngraving = document.querySelectorAll(".cstmfy_c_required")
    if(!isInlineEngraving && isInlineEngraving.length === 0){
      return console.log("Product IS NOT INLINE ENGRAVING")
   }

    //alert('inline engraving')

    setTimeout(()=>{
      const checkbox = document.querySelector(".pplrcheckbox.cstmfy_c_required ")
      console.log(checkbox)
  
      if(!checkbox){
        return console.log("Cant find checkbox for inline engraving type, flashlight")
      }
  
      checkbox.addEventListener('change', async(e)=>{
        if(e.target.checked){
          const additionalProduct = document.querySelector("[data-js-selected-additional-product-id]")
          const {value} = additionalProduct
          //alert(value)
  
          const payload = {
                'items': [{
                  'id': Number(value),
                  'quantity': 1
                }]
             };
      
          await postCartData(payload)
          console.log("POST flashlight inline engraving")
        }
      })
    },1000)

 
  }) 
});
    
